import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import {
  QUEUE_FIXED_WIDTH,
  QUEUE_FULL_WIDTH,
} from '@rsos/constants/queueWidths';

export const Container = styled(Box).attrs(() => ({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  position: 'relative',
  width: QUEUE_FIXED_WIDTH,
  height: 50,
  backgroundColor: 'background',
  color: 'background',
  cursor: 'pointer',
}))`
  flex: 0 0 auto;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  font-family: 'Roboto', sans-serif;
  user-select: none;
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${QUEUE_FULL_WIDTH};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  padding: 5px 24px;
`;

export const Title = styled(Text).attrs({
  color: 'primaryBase',
  fontWeight: 'bold',
})``;

export const Subtitle = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})``;

export const RemoveAll = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 2px;
  border-top: ${({ theme }) => `3px solid ${theme.colors.background}`};
  border-bottom: ${({ theme }) => `3px solid ${theme.colors.background}`};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  transition: background-color 0.3s;
  user-select: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
`;
